import Button from "components/Form/Button";
import styled from "styled-components";

export const Content = styled.div.attrs({
})`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
`;

export const ButtonSelected = styled(Button).attrs({
  noIcon: true,
  gradient: true,
  small: true,
})`
`;

export const ButtonDefault = styled(Button).attrs({
  outlineGradient: true,
  noIcon: true,
  white: true,
})`
`;

export const PaginationContainer = styled.div.attrs({
})`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  justify-content: center;
  padding: 16px 0;
  gap: 16px;
  overflow: visible;
  margin: 0 auto;

  @media (max-width: 768px) {
    padding: 12px 0;
  }

`;

export const PaginationQuantity = styled.div.attrs({})`

  font-size: 14px;
  font-weight: 600;
  line-height: 21.28px;
  text-align: center;
`;
